import Link from 'next/link';
import { Alert } from '@mui/material';
// Components
import { AlertBody } from '@/common/index';
// Styles & Assets
import styles from './walletAlerts.module.css';
import arrow from '@/icons/fontawesome/arrow-right-red.svg';

export function InsufficientGasAlert({
  feeCoinSymbol,
  formattedAvailableFeeBalance,
  walletVersion,
}) {
  return (
    <div className={styles.errorContainer}>
      <Alert severity="error" variant="outlined">
        <AlertBody
          className={styles.errorGas}
          header="Insufficient Funds."
          body={`Your wallet ${walletVersion} does not have enough ${feeCoinSymbol} to cover your estimated gas fee`}
        >
          Available {feeCoinSymbol}: {formattedAvailableFeeBalance}
        </AlertBody>
      </Alert>
    </div>
  );
}

export function InsufficientFundsAlert({
  walletVersion,
  walletInfo,
  hasDuplicateWallets,
  brandName,
  walletInfoLegacy,
}) {
  return (
    <div className={styles.errorContainer}>
      <Alert severity="error" variant="outlined">
        <AlertBody
          header="Insufficient Funds."
          body={`Your wallet ${walletVersion} doesn't have enough ${walletInfo?.cryptoAsset?.display.symbol} to complete this transaction.`}
        >
          {!hasDuplicateWallets &&
            walletInfoLegacy?.usd > 0 &&
            walletInfoLegacy?.cryptoAsset?.uniqueKey && (
              <div>
                <Link
                  href={`/dashboard/wallet/assets/${walletInfoLegacy.cryptoAsset.uniqueKey}?core=false&importWallet=true&shopping=true`}
                >
                  <a
                    className={styles.errorActionLink}
                    data-core-qa="fundWalletButtonTransfer"
                  >
                    Transfer funds from {brandName}{' '}
                    {walletInfo?.cryptoAsset?.display.symbol} Wallet
                    <img src={arrow.src} alt="arrow" className={styles.arrowIcon} />
                  </a>
                </Link>
              </div>
            )}
        </AlertBody>
      </Alert>
    </div>
  );
}
